



























import tools from "@/tools.coffee"
import settings from "@/settings.coffee"

export default {
    "name": "StratalisPublication"
    "props": {
        "context": {
            "type": Object
            "required": true
        }
        "review": {
            "type": Object,
            "required": true
        }
        "human_created_on": String

    }
    "data": ()->
        self = this
        return {
            "content": {"uid": "0"},
            "success_img_path": require("@/assets/success_"+String(self.context.uid[0])+".gif")
        }
    "methods":
        "get_link": (state, data)->
            ret = null
            if this.$store.state.profile.is_superuser
                if ["stratalis_pending", "stratalis_failed", "stratalis_done"].indexOf(state.key) >= 0
                    ret = settings.backendUrl+"/admin/stratalis_job_info/"+data.job_uuid
                if ['request_sent', 'request_rejected'].indexOf(state.key) >= 0 and data.StratalisRequest_pk
                    ret = settings.backendUrl+"/admin/stratalis_api/stratalisrequest/"+data.StratalisRequest_pk
            return ret
        "get_status_icon": (s, index)->
            #all_status = Object.keys(this.context.data.POSSIBLE_STATUS)
            #this.context.data.Status.indexOf(s)
            #status_index = all_status.indexOf(s.key)
            #console.log(s, status_index, current_status_index, all_status)
            #if status_index > current_status_index
            #    ret = 'fa-pause-circle has-text-grey'
            #if status_index < current_status_index
            #    ret = 'fa-check-circle has-text-success'
            #if status_index == current_status_index
            #    ret = 'fa-dot-circle has-text-warning'
            if index == this.context.data.Status.length - 1
                ret = 'bi-record-circle has-text-warning'
            else if index < this.context.data.Status.length - 1
                ret = 'bi-check-circle has-text-success'
            if s.key == 'request_rejected'
                ret = 'bi-stopwatch has-text-danger'
            if s.key == 'request_failed'
                ret = 'bi-stopwatch has-text-danger'
            if s.key == 'stratalis_failed'
                ret = 'bi-stopwatch has-text-danger'
            if s.key == 'stratalis_done'
                ret = 'bi-check-circle has-text-success'
            return ret

        "get_status_text": (s, index)->
            if index == this.context.data.Status.length - 1
                    ret = 'has-text-warning'
                else if index < this.context.data.Status.length - 1
                    ret = 'has-text-success'
                if s.key == 'request_rejected'
                    ret = 'has-text-danger'
                if s.key == 'request_failed'
                    ret = 'has-text-danger'
                if s.key == 'stratalis_failed'
                    ret = 'has-text-danger'
                if s.key == 'stratalis_done'
                    ret = 'has-text-success'
                return ret
        "getTextFromReview": (review, fr)->
            ret = ""
            for r in review.state_set
                if r.class_name == "AnswerAccepted"
                    if fr
                        ret = r.data.answer.text_fr
                    else
                        ret = r.data.answer.text_native
            return ret
        "random_number": ()->
            return String(Math.floor(Math.random() * 10))
        "copy": (text)->
            textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            this.$store.dispatch("notify",{
                level: "success",
                text: "Copié!",
                seconds: 2
            }) 
        "delete_state": ()->
            @$emit("state:delete_state")
    "mounted": ()->       
            
    "created": ()->
        @content = tools.deep_copy(@context)
}
